export default __webpack_public_path__ + "static/makula-makuladegeneration-augenpermanence-80b2e2c3de14ad3d90c0861369923fad.jpg";